import { motion } from 'framer-motion'
import styled, { css } from 'styled-components'
import { BrandLogo } from '@velasca/ui/brand-logo'
import { UnstyledList } from '@velasca/ui/unstyled-list'
import CurrencySelect from '../CurrencySelect'

export const Header = styled.div<{
  isOpen: boolean
  top: boolean
  animationDone: boolean
  $height: number
}>`
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;

  ${({ isOpen, animationDone, $height }) =>
    (isOpen || !animationDone) &&
    css`
      height: ${$height}px;
    `};
`

export const Navbar = styled.nav<{
  isOpen: boolean
  top: boolean
  sticky: boolean | string
}>`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: ${({ isOpen }) => (isOpen ? 'auto' : 'hidden')};
  background: ${({ theme, isOpen, top, sticky }) =>
    (isOpen || !top || sticky) && theme.colors.boxBackground};
  transition: background 0.2s cubic-bezier(0, 0, 0, 1) 0s;
`

export const LogoContainer = styled.h1`
  font-size: 1.6rem;
  line-height: 1;
`

export const MenuLists = styled(motion.div)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 2rem;
  background: #f5f5f5;
  flex: 1;
  overflow-y: scroll;
`

export const FirstLevelMenuTitle = styled.span<{ isExpanded?: boolean }>`
  font-family: ${({ theme }) => theme.fonts.brand};
  font-weight: 600;
  font-size: 1.5rem;
  color: ${({ theme, isExpanded }) =>
    isExpanded ? theme.colors.primary : theme.colors.text.primary};
  line-height: 1.75rem;
  text-transform: uppercase;
  margin-bottom: 0.75rem;
`
const Chunk = styled.div`
  margin: 0.5rem;
  flex: 33.33%;
`

export const StartChunk = styled(Chunk)`
  display: flex;
  justify-content: flex-start;
`

export const CenterChunk = styled(Chunk)`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const EndChunk = styled(Chunk)`
  margin-right: 12px;
  justify-content: flex-end;
`

export const LinkNoDecoration = styled.a`
  &:hover,
  &:link,
  &:visited,
  &:active {
    text-decoration: none;
  }
`

export const Link = styled(LinkNoDecoration)`
  display: flex;
  align-items: center;
`

export const RightSideContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
`

export const StyledBrandLogoExtended = styled(BrandLogo.Extended)<{
  variant: 'primary' | 'white'
}>`
  width: 12rem;
  height: auto;
  transition: all 0.2s cubic-bezier(0, 0, 0, 1) 0s;
`

export const Bar = styled.div<{
  isOpen: boolean
  top: boolean
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 0.5rem;

  background: ${({ theme, isOpen, top }) =>
    isOpen || !top ? theme.colors.boxBackground : 'trasparent'};
  transition: all 0.2s cubic-bezier(0, 0, 0, 1) 0s;
`

export const CurrencySelector = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding: 0.25rem 0 0.75rem;
`

export const CurrencyTitle = styled(FirstLevelMenuTitle)`
  margin-bottom: 0;
`

export const Select = styled(CurrencySelect)`
  font-size: 1.6rem !important;
  min-width: 8rem;
  max-width: 10rem;
  padding: 0 0 0 1.15rem;
  margin-bottom: 0;
  line-height: 2.3rem;
`

export const LowerMenu = styled(UnstyledList)`
  margin-top: 4rem;
`

export const LowerMenuItem = styled.li`
  padding: 0.8rem 0;
`
